import "../styles/embed-notification-panel.scss";
import { useSelector } from "react-redux";
import actions from "../actions/actions";
import navigate from "../utilities/navigation";

function timeAgo(dateStr) {
  if (!dateStr) return "";
  const diff = Math.floor(
    (Date.now() - new Date(dateStr + "Z").getTime()) / 1000,
  );
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

function iconClass(notification) {
  const type = (notification?.type || "").toLowerCase();
  if (type.includes("fail") || notification?.isError)
    return "fas fa-exclamation-triangle embed-notif-panel__icon--error";
  if (type.includes("reply") || type.includes("message"))
    return "fas fa-envelope";
  return "fas fa-bell";
}

export default function EmbedNotificationPanel({ onClose }) {
  const items = useSelector((store) => store.embedNotifications.items);
  const unreadCount = useSelector(
    (store) => store.embedNotifications.unreadCount,
  );

  async function handleItemClick(notification) {
    if (!notification.isRead) {
      await actions.embedNotifications.markRead(notification.id);
    }
    onClose();
    if (notification.alertId)
      navigate(`/embeded-alert?id=${notification.alertId}`);
  }

  async function handleMarkAllRead(e) {
    e.stopPropagation();
    if (unreadCount === 0) return;
    await actions.embedNotifications.markAllRead();
  }

  return (
    <div className="embed-notif-panel">
      <div className="embed-notif-panel__header">
        <span className="embed-notif-panel__title">Notifications</span>
        {unreadCount > 0 && (
          <button
            className="embed-notif-panel__mark-all"
            onClick={handleMarkAllRead}
          >
            Mark all read
          </button>
        )}
      </div>

      <div className="embed-notif-panel__list">
        {items.length === 0 ? (
          <div className="embed-notif-panel__empty">
            <i className="fas fa-bell-slash" />
            <span>No notifications yet</span>
          </div>
        ) : (
          items.map((n) => (
            <div
              key={n.id}
              className={
                "embed-notif-panel__item" +
                (n.isRead ? "" : " embed-notif-panel__item--unread")
              }
              onClick={() => handleItemClick(n)}
            >
              <i className={`${iconClass(n)} embed-notif-panel__icon`} />
              <div className="embed-notif-panel__content">
                <span className="embed-notif-panel__item-title">{n.title}</span>
                {n.body && (
                  <span className="embed-notif-panel__item-body">{n.body}</span>
                )}
                <span className="embed-notif-panel__item-time">
                  {timeAgo(n.createdAt)}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
